import { JSX } from "react";
import Thumbnail from "../thumbnail/Thumbnail";
import NameAndStatus from "../name-and-status/NameAndStatus";
import { StyledAccordion, StyledAccordionSummary, StyledFileRow } from "../StyleComponents";
import AccordionDetails from "@mui/material/AccordionDetails";
import { EditForm, SaveEditFormResponse, EntryMetadataStructure } from "@kaltura/mediaspace-shared-edit-entry";
import { FileRowProps } from "../FileRow";

export interface FileRowAccordionProps extends FileRowProps {
    isOpen: boolean;
    entryId: string;
    entryName: string;
    actions?: JSX.Element;
    onSubmitStarted: () => void;
    onSubmit: (data: SaveEditFormResponse) => void;
    formData: EntryMetadataStructure;
}

/**
 * file row accordion - suitable for multiple file upload
 */
export const FileRowAccordion = (props: FileRowAccordionProps) => {
    const {
        className,
        isOpen,
        entryId,
        entryName,
        actions,
        onReadyForPublish,
        onBeforeSubmit,
        onCanSaveForm,
        onSubmitStarted,
        onSubmit,
        formData,
        fileInfo,
        editForm,
        editFormComponents,
        shouldClose,
        onClose,
        formId,
        showEditFormButtons,
        showCancelButton,
        saveButtonLabel,
        allowSaveUntouched,
    } = props;

    return (
        <StyledAccordion
            className={className}
            slotProps={{ transition: { unmountOnExit: true } }}
            disableGutters
            elevation={0}
            expanded={isOpen}
        >
            <StyledAccordionSummary id={`${entryId}-row`} aria-controls={`${entryId}-edit`}>
                <StyledFileRow isOpen={isOpen} className={"kms-ds-upload-media-file-row"}>
                    <Thumbnail file={fileInfo} />
                    <NameAndStatus name={entryName} metadata={fileInfo.fileMetaData} />
                    {actions}
                </StyledFileRow>
            </StyledAccordionSummary>
            <AccordionDetails>
                <EditForm
                    entryIds={[entryId]}
                    onCanSaveForm={onCanSaveForm}
                    onReadyForPublish={onReadyForPublish}
                    onSubmitStarted={onSubmitStarted}
                    onSubmit={onSubmit}
                    formData={formData}
                    fieldsStructure={editForm}
                    components={editFormComponents}
                    shouldClose={shouldClose}
                    onClose={onClose}
                    formId={formId}
                    showEditFormButtons={showEditFormButtons}
                    showCancelButton={showCancelButton}
                    saveButtonLabel={saveButtonLabel}
                    allowSaveUntouched={allowSaveUntouched}
                    onBeforeSubmit={onBeforeSubmit}
                />
            </AccordionDetails>
        </StyledAccordion>
    );
};
